/*
  Wines carousel — Swiper init for sections/wines-carousel.liquid.

  Swiper itself is loaded once in layout/theme.liquid, so this only wires up the
  instances. Each section is initialised against its own arrows rather than the
  bundle's default `swiper-button-prev` / `-next` classes, which keeps the arrow
  styling in section-wines-carousel.css and keeps two carousels on one page from
  driving each other.
*/
(function () {
  const READY = 'winesCarouselReady';

  function initCarousel(viewport) {
    // shopify:section:load fires on the editor's own re-renders as well, so a
    // viewport that already has a Swiper on it is left alone.
    if (viewport.dataset[READY] === 'true') return;

    const section = viewport.closest('.wines-carousel');
    if (!section) return;

    viewport.dataset[READY] = 'true';

    new Swiper(viewport, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      watchOverflow: true,
      keyboard: {enabled: true},
      a11y: {enabled: true},
      navigation: {
        prevEl: section.querySelector('[data-wines-carousel-prev]'),
        nextEl: section.querySelector('[data-wines-carousel-next]'),
        disabledClass: 'wines-carousel__arrow--disabled',
        lockClass: 'wines-carousel__arrows--locked',
      },
      breakpoints: {
        750: {spaceBetween: 20},
        990: {spaceBetween: 24},
      },
    });
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-wines-carousel]').forEach(initCarousel);
  }

  function start() {
    if (typeof Swiper === 'undefined') return;
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-init the one section the theme editor just re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    if (typeof Swiper === 'undefined') return;
    initAll(event.target);
  });
})();
